import {IntermediatePart} from "../../intermediatePart";

export default class FridgeShadow extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'fridge_shadow';
    this.partName = 'Fridge Shadow';
    this.visible = false;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new FridgeShadow());
  }

  setLayers(layout) {

    const fridge = this.getParent().fridge;
    if (fridge && fridge.disabled) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);
  }

  setDefault() {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    this.activeFeature = filteredFeatures[0];
  }

  getArrayOfConditions() {
    return [{
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Appliances.FridgeShadow;
    }
  }
}